import ProfissionalAPI from "../../../servicos/ProfissionalAPI"

import { motion } from "framer-motion"
import { useContext, useEffect, useState, useRef } from "react"
import { useNavigate } from "react-router-dom"
import { Spinner } from "../../../componentes/Spinner"
import { Campo } from "../../../componentes/form/campo"

import { parse } from "date-fns"

import { ContextoGeral } from "../../../contextos/ContextoGeral"

import { Alert, Backdrop, Button, Card, CircularProgress, Collapse, IconButton, MenuItem, Zoom, Portal } from "@mui/material"
import { MdLogout, MdOpenInNew } from "react-icons/md"
import Gears from "../../../componentes/Gears"
import CheckPermission from "../../../servicos/config/CheckPermission"
import MensagemApp from "../../../servicos/config/MensagemApp"
import { configAnim } from "../../../servicos/config/configAnim"

import "./cadastroPos.module.css"
import { CameraAlt, Close, Collections, PictureAsPdf } from "@mui/icons-material"
import useCamera from "../../../hooks/general/useCamera"
import useGallery from "../../../hooks/general/useGallery"
import { print } from "../../../servicos/Uteis"
import { APISEM } from "../../../servicos/APISEM";

export function CadastroPos() {
	const navegar = useNavigate()

	const [carregando, setCarregando] = useState(true)
	const [erroAPI, setErroAPI] = useState(false)
	const [cadastroCompleto, setCadastroCompleto] = useState(false)
	const [dadosAdicionaisCompleto, setDadosAdicionaisCompleto] = useState(false)
	const [validRedirect, setValidRedirect] = useState(false)

	const [resultado, setResultado] = useState({})
	const [resposta, setResposta] = useState("")

	const [mostrarDados, setMostrarDados] = useState(true)
	const [mostrarArquivos, setMostrarArquivos] = useState(true)

	const [msgCampos, setMsgCampos] = useState(false)
	const [msgArquivos, setMsgArquivos] = useState(false)

	const mostrarTabAtiva = mostrarDados ? "dadosGerais" : "arquivos"
	const [tabAtiva, setTabAtiva] = useState(mostrarTabAtiva)

	const [enviando, setEnviando] = useState(false)

	const { dados, setDados, deslogar } = useContext(ContextoGeral)

	const formataDataAmericano = (text) => {
		let myArray = text.split("/")
		let dataFormt = `${myArray[2]}-${myArray[1]}-${myArray[0]}`
		return dataFormt
	}

	const formataDataBrasileiro = (text) => {
		let myArray = text.split("-")
		let dataFormt = `${myArray[2]}/${myArray[1]}/${myArray[0]}`
		return dataFormt
	}

	async function handleCampo(event) {
		let json = { ...resultado };
		if (!json.campos) return;

		const chave = event.target.id || event.target.name;
		if (!chave || chave === "radio-buttons-group") return;

		let campo = json.campos[chave];
		if (!campo) {
			const foundKey = Object.keys(json.campos).find((k) => json.campos[k]?.chave === chave);
			if (!foundKey) return;
			campo = json.campos[foundKey];
		}

		if (chave === "tipoVeiculo") {
			const icone = campo?.opcoes?.find((opt) => opt.value == event.target.value)?.icone ?? "";
			campo.iconeEnviado = icone;
		}

		delete campo.erro;
		campo.valorEnviado = event.target.value;

		if (chave === "tipoCadastro") {
			const cnpj = json.campos.cnpj ?? Object.values(json.campos).find((c) => c?.chave === "cnpj");
			if (cnpj) {
				if (cnpj.obrigatorioOriginal === undefined) {
					cnpj.obrigatorioOriginal = !!cnpj.obrigatorio
				}
				cnpj.obrigatorio = event.target.value === "PF" ? false : cnpj.obrigatorioOriginal
			}
		}

		setResultado(json);
	}

	const handleSair = (event) => {
		deslogar()
	}

	async function handleCampoArquivo(event) {
		event.preventDefault();

		let json = { ...resultado };

		let statusPermissao = true;

		if (statusPermissao && !CheckPermission.checkCamera()) {
			statusPermissao = false;
			window.AndroidInterface.showPermissaoCamera(MensagemApp.msgPermissaoCamera);
		}

		if (statusPermissao && !CheckPermission.checkStorage()) {
			statusPermissao = false;
			window.AndroidInterface.showPermissaoArmazenamento(MensagemApp.msgPermissaoArmazenamento);
		}

		if (statusPermissao) {
			if (typeof window.AndroidInterface !== "undefined") {
				window.finalizouEnvio = function (res) {
					let retorno = JSON.parse(res);

					event.target.blur();

					if (retorno?.resultado) {
						print(retorno?.mensagem)

						if (json.arquivos?.[event.target.id]) {
							json.arquivos[event.target.id].valorEnviado = "Enviado";
							json.arquivos[event.target.id].enviado = true;
						}
						setResultado(json);

						let completo = true;
						let completoAdicionais = true;

						Object.keys(json.arquivos || {}).map((chave) => {
							if (json.arquivos[chave]?.valorEnviado == "" && json.arquivos[chave]?.obrigatorio) {
								completo = false;
							} else if (json.arquivos[chave]?.valorEnviado == "" && !json.arquivos[chave]?.obrigatorio) {
								completoAdicionais = false
							}
						})

						Object.keys(resultado.campos || {}).map((chave) => {
							if (resultado.campos[chave]?.valorEnviado == "" && resultado.campos[chave]?.obrigatorio) {
								completo = false;
							} else if (resultado.campos[chave]?.valorEnviado == "" && !resultado.campos[chave]?.obrigatorio) {
								completoAdicionais = false
							}
						})

						setDadosAdicionaisCompleto(completoAdicionais);
					} else {
						if (window.AndroidInterface)
							window.AndroidInterface.showAndroidVersion(retorno?.mensagem ?? MensagemApp.timeout);
					}
				}
			}

			let tipoDoc = event.target.id;
			let idProfissional = parseInt(dados.idProf);
			let token = dados.token;

			try {
				window.AndroidInterface.ativaCamera("DC", idProfissional, 0, 0, "FP", tipoDoc, "arquivosAdicionais", token);
			} catch (err) {
				alert(err)
			}
		}
	}

	async function enviarCadastroPos() {
		setEnviando(true);
		let formulario = document.querySelectorAll("#dadosGerais input, #dadosGerais select");

		let dadosFormulario = { idProf: dados.idProf };

		for (let i = 0; i < formulario.length; i++) {
			if (formulario[i].type === "radio") {
				if (!dadosFormulario.hasOwnProperty(`${formulario[i].name}`)) {
					let nomeRadio = formulario[i].name;
					let statusValor = document.querySelector(`input[name='${nomeRadio}']:checked`)?.value ?? "";

					dadosFormulario = {
						...dadosFormulario,
						[formulario[i].name]: statusValor,
					};
				}
			} else {
				if (formulario[i].getAttribute("data-tipo") == "dateSelect") {
					// VALIDANDO SE DATA DIGITADA É VÁLIDA
					if (parse(formulario[i].value, "dd/MM/yyyy", new Date()) != "Invalid Date") {
						if (formulario[i].value.replace(/[^\d.-]/g, "").length == 8) {
							let data = formulario[i].value;

							if (formulario[i].id == "datVecAntt" || formulario[i].id == "datVecApolice") {
								data = formataDataAmericano(data);
							}

							dadosFormulario = {
								...dadosFormulario,
								[formulario[i].id]: data,
							};
						}
					}
				} else {
					if (formulario[i].value) {
						dadosFormulario = {
							...dadosFormulario,
							[formulario[i].id]: formulario[i].value,
						};
					}
				}
			}
		}

		// valida cidade selecionada (somente se o campo existir na configuração)
		if (resultado?.campos?.cidade) {
			// Se o campo já foi enviado, usa o valor já enviado e não valida
			if (resultado?.campos?.cidade?.enviado) {
				// Campo já foi enviado, adiciona ao payload se houver valor
				if (resultado?.campos?.cidade?.valorEnviado) {
					dadosFormulario.cidade = resultado.campos.cidade.valorEnviado;
				}
			} else {
				// Campo ainda não foi enviado, valida normalmente
				const cidadeInput = document.getElementById("cidade");

				// se o input nem existe no DOM, não valida e não envia nada de cidade
				if (cidadeInput) {
					const cidadeValida = cidadeInput.dataset?.valid === "1";

					// se o usuário digitou algo mas não escolheu da lista, bloqueia
					if (!cidadeValida && cidadeInput.value) {
						setResposta(
							<Alert severity="error" className="text-center mb-3">
								Selecione uma cidade da lista antes de enviar.
							</Alert>
						);
						setEnviando(false);
						return; // bloqueia envio
					}

					// só adiciona ao payload se houver valor (evita chave vazia)
					const valorCidade = cidadeInput.value?.trim?.();
					if (valorCidade) {
						dadosFormulario.cidade = valorCidade;
					}
				}
			}
		}

		// "Onde ouviu sobre nós?" + "Onde nos conheceu?" na mesma chave: vazio → "Outros"; preenchido → valor do campo.
		const inputOndeConheceu = document.getElementById("ondeConheceuOutros");
		if (inputOndeConheceu) {
			const texto = (inputOndeConheceu.value || "").trim();
			const chavePrincipal = ["ondeOuviuNos", "ondeConheceu", "comoConheceu"].find(
				ch => resultado?.campos?.[ch] && isCampoOndeConheceu(resultado.campos[ch])
			);
			if (chavePrincipal) {
				dadosFormulario[chavePrincipal] = texto || "Outros";
			}
			delete dadosFormulario.ondeConheceuOutros;
		}

		dadosFormulario.icone = resultado?.campos?.tipoVeiculo?.iconeEnviado;
		let respostaAPI = await ProfissionalAPI.enviarCadastroPos(dados, dadosFormulario)

		if (respostaAPI?.resultado) {
			if (respostaAPI?.resultado) {
				if (!!window.AndroidInterface) {
					window.AndroidInterface.showAndroidVersion(respostaAPI.mensagem);
				}

				setResposta(<div>
					<Alert severity="success" className="text-center mb-3">
						{respostaAPI.mensagem}
					</Alert>
					<Button onClick={() => setTabAtiva("arquivos")} className="my-3" variant="contained" color="primary">
						Enviar arquivos adicionais
					</Button>
				</div>);

				let completo = true;
				let arqCompleto = true;
				let completoAdicionais = true;

				const tipoVeiculo = resultado?.campos?.tipoVeiculo?.valorEnviado;

				Object.keys(resultado.campos || {}).map((chave) => {
					if (resultado.campos[chave]?.valorEnviado == "" && resultado.campos[chave]?.obrigatorio) {
						completo = false;
					} else if (resultado.campos[chave]?.valorEnviado == "" && !resultado.campos[chave]?.obrigatorio) {
						completoAdicionais = false;
					}

					if (['dataVencimentoHabilitacao', 'numeroHabilitacao', 'possuiBau', 'quantosLitros', 'placa', 'anoFabricacao', 'renavam', 'chassi', 'nAntt', 'datVecAntt', 'cilindradas', 'condumotoAberto'].includes(chave))
						if (tipoVeiculo == 'B')
							completo = true;

					if (['possuiBau', 'quantosLitros', 'PossuiMochila', 'condumotoAberto', 'cilindradas'].includes(chave))
						if (tipoVeiculo == 'U')
							completo = true;
				});


				Object.keys(resultado.arquivos || {}).map((chave) => {
					if (resultado.arquivos[chave]?.valorEnviado == "" && resultado.arquivos[chave]?.obrigatorio) {
						arqCompleto = false;
					} else if (resultado.arquivos[chave]?.valorEnviado == "" && !resultado.arquivos[chave]?.obrigatorio) {
						completoAdicionais = false;
					}

					if (['fotoHabilitacao', 'fotoAntt', 'fotoBau', 'fotoDocVeiculo', 'condumoto'].includes(chave)) {
						if (tipoVeiculo == 'B') {
							arqCompleto = true;
						}
					}

					if (['fotoBau', 'fotoBag', 'condumoto'].includes(chave)) {
						if (tipoVeiculo == 'U') {
							arqCompleto = true;
						}
					}
				})

				if (completo && arqCompleto) {
					setTabAtiva("cadastroCompleto")
					setCadastroCompleto(true)
				}

				setDadosAdicionaisCompleto(completoAdicionais);
			} else {
				setResposta(
					<Alert severity="error" className="text-center mb-3">
						{respostaAPI?.mensagem ?? MensagemApp.erroAPI}
					</Alert>
				);
			}
		} else if (respostaAPI?.codigo == 400) {
			if (respostaAPI?.dados?.erros && respostaAPI.dados.erros.length > 0) {
				let json = resultado;

				Object.values(resultado.campos).forEach((campo) => {
					respostaAPI.dados.erros.forEach((erro) => {
						if (campo.chave == erro.campo) {
							json.campos[campo.chave].erro = erro.mensagem;
						}
					});
				});

				setResultado(json)
			}
			setResposta(
				<Alert severity="error" className="text-center mb-3">
					{respostaAPI?.mensagem ?? MensagemApp.erroAPI}
				</Alert>
			)
		} else setResposta(<Alert severity="error" className="text-center mb-3">
			{MensagemApp.timeout}
		</Alert>)
		setEnviando(false)
	}

	// Identifica o campo "Onde você nos ouviu/viu?" (chave: ondeOuviuNos). Quando for este campo, o texto do backend fica oculto e só exibimos o select (Instagram, Facebook, Indicação, Outros); "Especifique" só aparece se escolher Outros.
	function isCampoOndeConheceu(campo) {
		
		if (!campo?.chave) return false;
		const chaveOk = campo.chave === "ondeOuviuNos" || campo.chave === "ondeConheceu" || campo.chave === "comoConheceu";
		const label = (campo.label ?? "").toLowerCase().normalize("NFD").replace(/\u0300/g, ""); // remove acentos
		const labelOk = /conheceu|onde.*nos|como.*soube|hear.*about|referencia|origem|como.*conhece/.test(label);
		return chaveOk || labelOk;
	}

	function filtrarCampos(campos) {

		const tipoVeiculo = campos?.tipoVeiculo ? [campos.tipoVeiculo] : [];
		const possuiBau = campos?.possuiBau ? [campos.possuiBau] : [];
		const quantosLitros = (campos?.possuiBau?.valorEnviado === 'S' && campos?.quantosLitros) ? [campos.quantosLitros] : [];

		const outrosCampos = Object.values(resultado.campos || {})
			.filter(e => e?.chave !== "tipoVeiculo") // Adiciona os outros campos
			.filter(e => e?.chave !== "possuiBau")
			.filter(e => e?.chave !== "quantosLitros")
			.filter(e => e?.chave !== "ondeConheceuOutros") // mostrado só quando "Outros" no select (ondeOuviuNos/ondeConheceu)
			.filter(e => e?.chave)
			.map((e, i) => { return e })

		return [...tipoVeiculo, ...possuiBau, ...quantosLitros, ...outrosCampos];
	}

	const CHAVES_PESSOAIS = [
		"tipoCadastro", "cpf", "cnpj", "razaoSocial", "tagPedagio", "meiAberto", "rg", "dataEmissao", "orgaoEmissor",
		"pis", "dataNascimento", "civil", "titulo", "nomePai", "nomeMae", "nacionalidade", "naturalidade",
		"contatoEmergencia", "fichaIdenCadastral", "endereco", "rua", "numero", "bairro", "complemento",
		"estado", "cidade", "cep", "numeroHabilitacao", "dataVencimentoHabilitacao", "dataAdmissao", "idNextel"
	]
	const CHAVES_VEICULO = [
		"tipoVeiculo", "possuiBau", "quantosLitros", "PossuiMochila", "veiculo", "marca", "modelo", "cor",
		"cilindradas", "placa", "anoFabricacao", "renavam", "chassi", "titularVeiculo", "nAntt", "datVecAntt",
		"datVecApolice", "capacidadeBau", "condumotoAberto", "placaVermelha"
	]
	const CHAVES_BANCARIOS = ["banco", "agencia", "conta", "operacao", "tipoConta", "contaTipo", "pix"]

	function campoOcultoPorVeiculo(e) {
		const icone = resultado?.campos?.tipoVeiculo?.iconeEnviado
		if (
			['dataVencimentoHabilitacao', 'numeroHabilitacao', 'possuiBau', 'quantosLitros', 'placa', 'anoFabricacao', 'renavam', 'chassi', 'nAntt', 'datVecAntt', 'cilindradas', 'condumotoAberto'].includes(e.chave) &&
			icone == 'bikeboy.png'
		)
			return true
		if (
			['possuiBau', 'quantosLitros', 'PossuiMochila', 'condumotoAberto', 'cilindradas'].includes(e.chave) &&
			['utilitario.png', 'carro.png', 'aereo.png', 'guincho.png', 'taxi.png', 'van.png', 'frete.png', 'fluvial.png'].includes(icone)
		)
			return true
		if (
			['possuiBau', 'quantosLitros'].includes(e.chave) &&
			['utilitario sem bau.png'].includes(icone)
		)
			return true
		if (e.chave == 'quantosLitros' && e.chave == 'N')
			return true
		return false
	}

	function secaoDoCampo(chave) {
		if (CHAVES_PESSOAIS.includes(chave)) return "pessoais"
		if (CHAVES_VEICULO.includes(chave)) return "veiculo"
		if (CHAVES_BANCARIOS.includes(chave)) return "bancarios"
		return "outros"
	}

	function ordenarCamposSecao(campos, ordem) {
		return [...campos].sort((a, b) => {
			const ia = ordem.indexOf(a.chave)
			const ib = ordem.indexOf(b.chave)
			const pa = ia === -1 ? 999 : ia
			const pb = ib === -1 ? 999 : ib
			return pa - pb
		})
	}

	function agruparCamposPorSecao(lista) {
		const grupos = { pessoais: [], veiculo: [], bancarios: [], outros: [] }
		lista.forEach((e) => {
			grupos[secaoDoCampo(e.chave)].push(e)
		})
		grupos.pessoais = ordenarCamposSecao(grupos.pessoais, CHAVES_PESSOAIS)
		grupos.veiculo = ordenarCamposSecao(grupos.veiculo, CHAVES_VEICULO)
		grupos.bancarios = ordenarCamposSecao(grupos.bancarios, CHAVES_BANCARIOS)

		return [
			{ id: "pessoais", titulo: "Dados pessoais", campos: grupos.pessoais },
			{ id: "veiculo", titulo: "Dados do veículo", campos: grupos.veiculo },
			{ id: "bancarios", titulo: "Dados bancários", campos: grupos.bancarios },
			{ id: "outros", titulo: "Outras informações", campos: grupos.outros },
		].filter((secao) => secao.campos.length > 0)
	}

	useEffect(() => {
		setDados(p => ({ ...p, posCadastro: true }))
	}, [])

	useEffect(() => {
		if (dados.dominio === undefined)
			deslogar()
	}, [dados])

	useEffect(() => {
		async function teste() {
			if (resultado?.redirecionamento && resultado.redirecionamento?.exibir == "S" && resultado.redirecionamento?.label && resultado.redirecionamento?.url) {
				try {
					new URL(resultado.redirecionamento?.url)
					setValidRedirect(true)
				} catch (err) {
					setValidRedirect(false)
				}
			}
		}
		teste()
	}, [resultado])

	useEffect(() => {
		async function buscarCampos() {
			let respostaAPI = null

			try {
				respostaAPI = await ProfissionalAPI.posCadastro(dados)
			} catch (erro) {
				console.error("[posCadastro] falha ao buscar campos", erro)
				respostaAPI = { codigo: 400, mensagem: MensagemApp.msgErroApi }
			}

			if (respostaAPI?.resultado && respostaAPI?.dados != "") {
				let todosCampos = true

				let qCampos = 0
				for (let prop in respostaAPI.dados.campos) {
					const valorEnviado = respostaAPI.dados.campos[prop]?.valorEnviado
					const obr = respostaAPI.dados.campos[prop]?.obrigatorio

					if (valorEnviado == "") {
						if (obr) todosCampos = false
						qCampos++
					}
				}

				let todosArquivos = true
				let qArquivos = 0
				for (let prop in respostaAPI.dados.arquivos) {
					const valorEnviado = respostaAPI.dados.arquivos[prop]?.valorEnviado
					const obr = respostaAPI.dados.arquivos[prop]?.obrigatorio

					if (valorEnviado == "") {
						if (obr) todosArquivos = false
						qArquivos++
					}
				}

				if (qCampos == 0) setMsgCampos(true)
				if (qArquivos == 0) setMsgArquivos(true)

				setMostrarDados(true)
				setMostrarArquivos(true)

				if (todosCampos && todosArquivos) {
					setTabAtiva("cadastroCompleto")
					setCadastroCompleto(true)
				}

				// Garante campo "Especifique" quando existir "Onde nos conheceu" (por chave ou por label)
				let dadosPos = respostaAPI.dados;
				const camposLista = Object.values(dadosPos?.campos ?? {});
				const labelOndeConheceu = (l) => /conheceu|onde.*nos|como.*soube|hear.*about|referencia|origem|como.*conhece/.test((l ?? "").toLowerCase().normalize("NFD").replace(/\u0300/g, ""));
				const temOndeConheceu = dadosPos?.campos?.ondeOuviuNos || dadosPos?.campos?.ondeConheceu || dadosPos?.campos?.comoConheceu ||
					camposLista.some(c => labelOndeConheceu(c?.label));
				if (temOndeConheceu && !dadosPos.campos.ondeConheceuOutros) {
					dadosPos = {
						...dadosPos,
						campos: {
							...dadosPos.campos,
							ondeConheceuOutros: {
								chave: "ondeConheceuOutros",
								label: "Especifique",
								tipoCampo: "texto",
								valorEnviado: "",
								obrigatorio: false,
							},
						},
					};
				}
				if (dadosPos?.campos?.cnpj && dadosPos.campos.cnpj.obrigatorioOriginal === undefined) {
					dadosPos.campos.cnpj.obrigatorioOriginal = !!dadosPos.campos.cnpj.obrigatorio
				}
				if (dadosPos?.campos?.tipoCadastro?.valorEnviado === "PF" && dadosPos?.campos?.cnpj) {
					dadosPos.campos.cnpj.obrigatorio = false
				}
				setResultado(dadosPos);
				setCarregando(false);
			} else {
				if (respostaAPI?.aux == "tokenInvalido") deslogar()

				setCarregando(false);
				setResultado(respostaAPI ?? { codigo: 400, mensagem: MensagemApp.msgErroApi });
				setErroAPI(true);
			}
		}

		if (carregando) buscarCampos()
	}, [carregando])

	useEffect(() => {
		if (!mostrarDados && !mostrarArquivos) {
			setCadastroCompleto(true)
			setTabAtiva("cadastroCompleto")
		} else {
			if (mostrarDados)
				setTabAtiva("dadosGerais")
			else if (mostrarArquivos)
				setTabAtiva("arquivos")
		}
	}, [mostrarDados, mostrarArquivos])

	useEffect(() => {
		let completo = true;

		let dadosCompletos = true;
		if (resultado?.campos) {
			Object.keys(resultado.campos).map((chave) => {
				if (resultado.campos[chave]?.enviado == "" && resultado.campos[chave]?.obrigatorio) {
					completo = false;
					dadosCompletos = false;
				} else if (resultado.campos[chave]?.enviado == "" && !dadosAdicionaisCompleto) {
					completo = false;
					dadosCompletos = false;
				}
			});

			if (dadosCompletos) {
				// setMostrarDados(false)
				if (!mostrarArquivos) {
					setCadastroCompleto(true);
				}
			}
		}

		if (resultado?.arquivos) {
			let arquivosCompletos = true;
			Object.keys(resultado.arquivos).map((chave) => {
				if (resultado.arquivos[chave]?.enviado == "" && resultado.arquivos[chave]?.obrigatorio) {
					completo = false;
					arquivosCompletos = false;
				} else if (resultado.arquivos[chave]?.enviado == "" && !dadosAdicionaisCompleto) {
					completo = false;
					arquivosCompletos = false;
				}
			});

			if (arquivosCompletos) {
				// setMostrarArquivos(false)
				if (!mostrarDados) {
					setCadastroCompleto(true);
				}
			}

			if (completo) {
				setCadastroCompleto(true);
				setDadosAdicionaisCompleto(true);
			}
		}
	}, [resultado])

	return <motion.div
		className="mx-2"
		initial={configAnim.initial}
		animate={configAnim.animate}
		exit={configAnim.exit}
		transition={configAnim.transition}
	>
		{carregando
			? <div className="vh-screen">
				<Spinner />
			</div>
			: <div style={{
				minHeight: "var(--app-vh)",
				paddingTop: "var(--safe-top, 0px)",
				paddingBottom: "var(--safe-bottom, 0px)",
				boxSizing: "border-box"
			}}>
				<header style={{ position: "relative" }}>
					<button style={{ marginTop: "-5px" }} className="over" onClick={handleSair}>
						<MdLogout size={28} />
						Sair
					</button>
					<div className="floatCenter mt-1">PÓS CADASTRO</div>
				</header>
				{erroAPI
					? <>
						<Alert severity="warning" className="text-center mt-4">
							{resultado.mensagem}
						</Alert>
						<footer></footer>
					</>
					: <>
						<div>
							<h3 className="text-center mt-3">Legal! Precisamos de mais algumas informações suas.</h3>
							<div className="flex my-2 gap-3">
								<button disabled={tabAtiva == "dadosGerais"} onClick={() => setTabAtiva("dadosGerais")}>Dados Gerais</button>
								<button disabled={tabAtiva == "arquivos"} onClick={() => setTabAtiva("arquivos")}>Arquivos</button>
							</div>

							{tabAtiva == "dadosGerais" && (mostrarDados && resultado.campos) && <div style={{ maxHeight: "calc(var(--app-vh) - 11rem - var(--safe-top, 0px))", overflowY: "auto" }}>
								{msgCampos
									? <Alert className="w-full text-wrap">
										Todos os campos necessários já foram enviados, obrigado!
									</Alert>
									: <>
										<form id="dadosGerais">
											{agruparCamposPorSecao(
												filtrarCampos(resultado.campos).filter((e) => !campoOcultoPorVeiculo(e) && !(e.enviado && !e.erro))
											).map((secao) => (
												<div key={secao.id} className="mb-3">
													<h4
														className="mt-3 mb-1 font-semibold"
														style={{ borderBottom: "1px solid #d0d0d0", paddingBottom: 4 }}
													>
														{secao.titulo}
													</h4>
													{secao.campos.map((e, i) => {
												let atributos = { autorizado: 0 };

												if (e.obrigatorio)
													atributos["obrigatorio"] = "obrigatorio";

												if (e.enviado)
													atributos["autorizado"] = 1;

												atributos["value"] = "";

												if (e?.valorEnviado != "" && e?.valorEnviado != undefined) {
													let value = e.valorEnviado;

													if (e.chave == "datVecApolice" || e.chave == "datVecAntt") {
														value = formataDataBrasileiro(value);
													} else if (e.tipoCampo == "radio" && e.valorEnviado == "") {
														value = "";
													}

													atributos["value"] = value;

													if (e?.enviado) {
														atributos["disable"] = true;
													}
												} else if (e.default) {
													atributos["value"] = e.default;
												} else if (e?.valor != "") {
													atributos["value"] = e.valor;
												} else {
													atributos["value"] = "";
												}

												// CAMPO PIX
												if (e.chave == "pix") {
													return (
														<div key={e.chave || i}>
															<Zoom className="mt-3" in={true} style={{ transitionDelay: i * (1000 / Object.keys(resultado.campos).length) }}>
																<div>
																	<Pix e={e} atributos={atributos} handleCampo={handleCampo} />
																</div>
															</Zoom>
														</div>
													);
												}

												// CAMPO CIDADE COM AUTOCOMPLETE
												if (e.chave === "cidade") {
													return (
														<div style={{ display: resultado?.campos?.cidade?.enviado ? 'none' : 'block' }} className="mb-4 mt-3" key={e.chave || i}>
															<Zoom className="mt-3" in={true} style={{ transitionDelay: i * (1000 / Object.keys(resultado.campos).length) }}>
																<div>
																	<AutocompleteCidade
																		id={e.chave}
																		value={atributos.value}
																		uf={resultado?.campos?.estado?.valorEnviado || ""} // <<--- AQUI ENTRA O UF
																		onChange={(novaCidade) =>
																			handleCampo({ target: { id: e.chave, value: novaCidade } })
																		}
																		placeholder={e.label}
																		obrigatorio={e.obrigatorio}
																	/>

																	{!!e.erro && (
																		<p className="mt-1 text-sm text-red-600">{e.erro}</p>
																	)}
																</div>
															</Zoom>
														</div>
													);
												}

												// CAMPO "Onde nos ouviu" (chave: ondeOuviuNos): só exibe o SELECT (campo texto do backend fica oculto). Opções do backend ou padrão (Instagram, Facebook, Indicação, Outros). "Especifique" só aparece quando selecionar Outros.
												if (isCampoOndeConheceu(e)) {
													const opcoesOndeConheceu = e?.opcoes?.length
														? e.opcoes
														: [
															{ value: "Instagram", label: "Instagram" },
															{ value: "Facebook", label: "Facebook" },
															{ value: "Indicacao", label: "Alguém me indicou o app" },
															{ value: "Outros", label: "Outros" },
														];
													const valorOutros = resultado?.campos?.ondeConheceuOutros?.valorEnviado ?? "";
													const atributosOutros = resultado?.campos?.ondeConheceuOutros
														? {
															value: valorOutros,
															obrigatorio: false,
															autorizado: resultado.campos.ondeConheceuOutros.enviado ? 1 : 0,
															disable: !!resultado.campos.ondeConheceuOutros.enviado,
														}
														: { value: "", obrigatorio: false };
													const valorSelect = (resultado?.campos?.[e.chave]?.valorEnviado ?? "").toString().trim();
													const ehOutros = (v) => (String(v).toLowerCase() === "outros" || String(v).toLowerCase() === "outro");
													const mostrarCampoOutros = ehOutros(valorSelect);
													const campoOutros = resultado?.campos?.ondeConheceuOutros;
													return (
														<div key={e.chave || i}>
															<Zoom className="mt-3" in={true} style={{ transitionDelay: i * (1000 / Object.keys(resultado.campos).length) }}>
																<div
																	className={e.erro ? "campo-forcar-erro" : ""}
																	style={{
																		opacity: atributos.autorizado && !e.erro ? 0 : 1,
																		display: atributos.autorizado && !e.erro ? "none" : "block",
																	}}
																>
																	<Campo
																		id={e.chave}
																		label={e.label}
																		tipo="select"
																		options={opcoesOndeConheceu}
																		{...atributos}
																		value={valorSelect}
																		danger={!!e.erro}
																		onChange={handleCampo}
																	/>
																	{!!e.erro && <p className="p-1 font-normal text-sm text-red-600">{e.erro}</p>}
																</div>
															</Zoom>
															{mostrarCampoOutros && campoOutros && (
																<Zoom className="mt-3" in={true}>
																	<div
																		style={{
																			opacity: atributosOutros.autorizado ? 0 : 1,
																			display: atributosOutros.autorizado ? "none" : "block",
																		}}
																	>
																		<Campo
																			id="ondeConheceuOutros"
																			label="Onde nos conheceu?"
																			tipo="texto"
																			{...atributosOutros}
																			obrigatorio={false}
																			danger={!!campoOutros.erro}
																			onChange={handleCampo}
																		/>
																		{!!campoOutros.erro && (
																			<p className="p-1 font-normal text-sm text-red-600">{campoOutros.erro}</p>
																		)}
																	</div>
																</Zoom>
															)}
														</div>
													);
												}

												// Campos que precisam de dados adicionais
												if (resultado?.campos?.estado?.valorEnviado) {
													atributos["dominio"] = dados.dominio;
													atributos["token"] = dados.token;
													atributos["idProf"] = dados.idProf;
													atributos["estado"] = resultado.campos.estado.valorEnviado;
												}


												// RETURN PADRÃO (todos os outros campos)
												return (
													<div key={e.chave || i}>
														<Zoom className="mt-3" in={true} style={{ transitionDelay: i * (1000 / Object.keys(resultado.campos).length) }}>
															<div
																className={e.erro ? "campo-forcar-erro" : ""}
																style={{
																	opacity: atributos.autorizado && !e.erro ? 0 : 1,
																	display: atributos.autorizado && !e.erro ? "none" : "block",
																}}
															>
																<Campo
																	id={e.chave}
																	label={e.label}
																	tipo={e.tipoCampo === "date" ? "dateSelect" : e.tipoCampo}
																	options={e?.opcoes}
																	mask={
																		e.chave === "cnpj"
																			? "**.***.***/****-99"
																			: e.chave === "cpf"
																				? "999.999.999-99"
																				: undefined
																	}
																	{...atributos}
																	danger={!!e.erro}
																	onChange={(ev) => {
																		if (e.chave === "cnpj" && ev?.target) {
																			ev.target.value = String(ev.target.value || "").toUpperCase()
																		}
																		handleCampo(ev)
																	}}
																/>
																{!!e.erro && <p className="p-1 font-normal text-sm text-red-600">{e.erro}</p>}
															</div>

														</Zoom>
													</div>
												);
											})}
												</div>
											))}
										</form>


										<div className="w-full text-center mt-3" style={{ marginTop: "1rem", marginBottom: "10px !important" }}>
											{enviando
												? <div className="pb-3">
													<Spinner />
												</div>
												: resposta}

											<button
												onClick={enviarCadastroPos}
												className="w-full"
											>
												Enviar
											</button>
										</div>
										<div style={{ height: '10px' }}></div>
									</>}
							</div>}

							{tabAtiva == "arquivos" && <div className="h-dvh">
								{msgArquivos
									? <Alert className="w-full text-wrap">
										Todos os arquivos necessários já foram enviados, obrigado!
									</Alert>
									: resultado.arquivos
										? Object.values(resultado.arquivos).map((e, i) => {
											let atributos = {}

											let autorizado = false
											if (e.obrigatorio) {
												atributos["obrigatorio"] = "obrigatorio";
											}

											if (e.enviado) {
												autorizado = true;
											}

											if (e?.valorEnviado != "") {
												atributos["value"] = "Enviado com sucesso!";
												atributos["disable"] = true;
											} else {
												atributos["value"] = "";
												atributos["disable"] = false;
											}

											if (['fotoHabilitacao', 'fotoAntt', 'fotoBau', 'fotoDocVeiculo', 'condumoto'].includes(e.chave))
												if (resultado?.campos?.tipoVeiculo?.valorEnviado == 'B')
													return (<></>)

											if (['fotoBau', 'fotoBag', 'condumoto'].includes(e.chave))
												if (resultado?.campos?.tipoVeiculo?.valorEnviado == 'U')
													return (<></>)

											return <Arquivo
												key={i}
												e={e}
												atributos={atributos}
												autorizado={autorizado}
												handle={handleCampoArquivo}
												setCarregando={setCarregando}
											/>
										})
										: ""}
							</div>}

							{tabAtiva == "cadastroCompleto" && <div className="mt-3">
								<Gears />
								<Alert variant="filled" color="primary" className="mt-3">
									{resultado.msgAnalise}
								</Alert>

								<div className="toBottom w-full bg-white">
									{validRedirect && <Button
										className="mb-2"
										variant="contained"
										startIcon={<MdOpenInNew />}
										onClick={() => {
											if (!!window.AndroidInterface) {
												if (typeof window.AndroidInterface.redirectLink === "function") {
													window.AndroidInterface.redirectLink(resultado.redirecionamento.url)
												}
											}
										}}
										fullWidth>
										{resultado.redirecionamento.label}
									</Button>}
								</div>
							</div>}
						</div>
					</>}
			</div>}
	</motion.div>
}

function Arquivo({ e, atributos, autorizado, handle, setCarregando }) {
	const [ver, setVer] = useState("")
	const [open, setOpen] = useState(false)

	useEffect(() => {
		if (window.AndroidInterface)
			setVer(AndroidInterface?.recoverVersion())
	}, [])

	return <div
		className="mt-3"
		style={{
			opacity: e.enviado ? 0 : 1,
			display: e.enviado ? "none" : "block",
		}}
	>
		{ver >= 102.26
			? <button variant="contained" onClick={() => setOpen(true)} className="w-full">
				{e.label} {atributos?.obrigatorio && <span className="red">✶</span>}
			</button>
			: <Campo
				id={e.chave}
				label={e.label}
				tipo={e.tipoCampo}
				tabindex="-1"
				{...atributos}
				autorizado={autorizado}
				onChange={handle}

			/>}
		{open && <FotoModal
			label={e.label}
			open={open}
			close={() => setOpen(false)}
			identificador={e.chave}
			reload={() => {
				if (window.AndroidInterface)
					window.AndroidInterface.showAndroidVersion("Sucesso!")
				setOpen(false)
				setCarregando(true)
			}}
			onError={msg => {
				if (window.AndroidInterface)
					window.AndroidInterface.showAndroidVersion(msg ?? "Ops! Não foi possível salvar a imagem.")
				setOpen(false)
			}}
		/>}
	</div>
}

function FotoModal({ label, open, close, identificador, reload, onError }) {
	const { dados } = useContext(ContextoGeral)

	const [camera, setCamera] = useState(false)
	const [gallery, setGallery] = useState(false)
	const [pdf, setPdf] = useState(false)

	const [msgAndroid, setMsgAndroid] = useState("")

	const inputRef = useRef(null);

	const [ver, setVer] = useState("")

	useEffect(() => {
		if (window.AndroidInterface)
			setVer(AndroidInterface?.recoverVersion())
	}, [])


	let pdfByteParts = [];


	function base64ToUint8Array(base64) {
		// (Opcional) limpeza de ruídos — quase nunca precisa se veio do Android com NO_WRAP
		// const clean = base64.replace(/[^A-Za-z0-9+/=]/g, "");
		const binary = atob(base64);
		const len = binary.length;
		const bytes = new Uint8Array(len);
		for (let i = 0; i < len; i++) bytes[i] = binary.charCodeAt(i);
		return bytes;
	}

	window.addEventListener("message", (event) => {
		// Recebe mensagens do postWebMessage
		console.log("Recebe mensagens do postWebMessage")
		if (typeof window.onPdfChunk === "function") {
			window.onPdfChunk(event.data);
		}
	});

	window.onPdfChunkErro = function (msg) {
		setMsgAndroid(chunk.message)
	}

	window.onPdfChunk = async function (msg) {
		try {
			const chunk = typeof msg === "string" ? JSON.parse(msg) : msg;

			setMsgAndroid("Enviando...");

			if (chunk.error) {
				setMsgAndroid(chunk.message);
				return;
			}

			if (chunk.end) {
				// Verifica se todos os índices chegaram
				for (let i = 0; i < chunk.chunks; i++) {
					if (!pdfByteParts[i]) {
						console.error("Chunk faltando:", i);
						return;
					}
				}

				// Concatena todos os Uint8Array na ordem
				const totalLen = pdfByteParts.reduce((sum, part) => sum + part.length, 0);
				const merged = new Uint8Array(totalLen);
				let offset = 0;
				for (let i = 0; i < pdfByteParts.length; i++) {
					merged.set(pdfByteParts[i], offset);
					offset += pdfByteParts[i].length;
				}
				pdfByteParts = [];

				// Cria Blob/File do PDF
				const blob = new Blob([merged], { type: "application/pdf" });
				const file = new File([blob], "documento.pdf", { type: "application/pdf" });
				console.log("📄 PDF pronto:", file.name, file.size, file.type);

				const buffer = await file.arrayBuffer();
				const base64 = btoa(
					new Uint8Array(buffer).reduce((data, byte) => data + String.fromCharCode(byte), "")
				);

				const body = {
					arquivo: base64,
					idProf: dados.idProf,
					token: dados.token,
					identificador: identificador
				};

				try {
					const res = await ProfissionalAPI.salvarPdfCdn(dados, body);

					if (res.resultado) {

						// agora sim: chama arquivosPosCadastro depois do link do CDN
						const linkCdn = res.link || res.url; // depende de como o backend retorna

						const res2 = await ProfissionalAPI.arquivosPosCadastro(dados, {
							link: linkCdn,
							idProf: dados.idProf,
							identificador: identificador
						});

						if (res2.resultado) {
							setTimeout(() => reload(), 1500);
						} else {
							onError(res2.mensagem);
						}
					} else {
						onError(res.mensagem);
					}
				} catch (err) {
					console.error(err);
					onError("Erro ao enviar PDF");
				}
			} else {
				// Decodifica cada chunk Base64
				const bytes = base64ToUint8Array(chunk.data);
				pdfByteParts[chunk.index] = bytes;
			}
		} catch (e) {
			console.error("Erro processando chunk:", e, msg);
		}
	};

	return <Portal container={() => document.body}>
		<Backdrop in={open} sx={{
			position: "absolute",
			top: 0,
			height: "var(--app-vh)",
			backdropFilter: "blur(5px)",
			margin: "0 -0.5rem",
			zIndex: 5000
		}}>
			<Card className="p-3 relative" style={{ width: "80%" }}>
				<IconButton className="absolute right-2 top-0 mb-2 z-10" onClick={close}>
					<Close />
				</IconButton>
				<h5 className="mb-3">Como deseja enviar a foto de {label}?</h5>
				<div className="flex justify-between gap-3 w-full">
					{ver >= 102.42 ?
						<Button className="gap-1" onClick={() => {
							inputRef.current?.click()
							setCamera(false)
							setGallery(false)
							setPdf(true)
						}}><PictureAsPdf />PDF</Button>
						: ''
					}
					<input
						type="file"
						accept="application/pdf"
						style={{ display: "none" }}
						ref={inputRef}
						capture={false}
					/>
					<Button className="gap-1" onClick={() => {
						setCamera(true)
						setGallery(false)
						setPdf(false)
					}}><CameraAlt />Câmera</Button>
					<Button className="gap-1" onClick={() => {
						setCamera(false)
						setGallery(true)
						setPdf(false)
					}}><Collections />Galeria</Button>
				</div>
				{camera && <Camera
					onFinish={async URL => {
						await ProfissionalAPI.arquivosPosCadastro(dados, {
							link: URL,
							idProf: dados.idProf,
							identificador: identificador
						}).then(res => {
							if (res.resultado) {
								reload()
							} else {
								onError(res.mensagem)
							}
						})
					}}
					onError={() => {
						setCamera(false)
					}}
				/>}
				{gallery && <Gallery
					onFinish={async URL => {
						await ProfissionalAPI.arquivosPosCadastro(dados, {
							link: URL,
							idProf: dados.idProf,
							identificador: identificador
						}).then(res => {
							if (res.resultado) {
								reload()
							} else {
								onError(res.mensagem)
							}
						})
					}}
					onError={() => {
						setGallery(false)
					}}
				/>}

				{msgAndroid ??

					<Alert
						severity="error"
						variant="filled"
						color="primary"
						className="text-center mb-3 w-full text-wrap"
					>
						{msgAndroid}
					</Alert>

				}
			</Card>
		</Backdrop>
	</Portal>
}

function Camera({ onFinish, onError }) {
	useCamera(onFinish, onError)
	return <div className="text-center">
		<CircularProgress />
	</div>
}

function Gallery({ onFinish, onError }) {
	useGallery(onFinish, onError)
	return <div className="text-center">
		<CircularProgress />
	</div>
}

function Pix({ e, atributos, handleCampo }) {
	const [type, setType] = useState("")
	const [mask, setMask] = useState("")

	useEffect(() => {
		switch (type) {
			case "cpf":
				setMask("999.999.999-99")
				break;
			case "cnpj":
				// * = A-Z/0-9 (react-input-mask); últimos 2 DVs só numéricos
				setMask("**.***.***/****-99")
				break;
			case "email":
				setMask("")
				break;
			case "tel":
				setMask("+55 99 99999-9999")
				break;
			case "chave":
				setMask("")
				break;
		}
	}, [type])

	return <div>
		<div className="mt-3" style={{
			opacity: atributos.autorizado ? 0 : 1,
			display: atributos.autorizado ? "none" : "block",
		}} >
			<Campo
				id="tipoPix"
				tipo="select"
				label="Tipo de chave Pix"
				options={[
					{
						key: 0,
						value: "tel",
						label: "Telefone",
					},
					{
						key: 1,
						value: "email",
						label: "E-mail",
					},
					{
						key: 2,
						value: "cpf",
						label: "CPF",
					},
					{
						key: 3,
						value: "cnpj",
						label: "CNPJ",
					},
					{
						key: 4,
						value: "chave",
						label: "Chave Aleatória",
					},
				]}
				value={type}
				onChange={e => setType(e.target.value)}
			/>

			<div className="mt-3">
				<Campo
					id={e.chave}
					label={e.label}
					tipo={e.tipoCampo == "date" ? "dateSelect" : e.tipoCampo}
					mask={mask}
					options={e?.opcoes}
					{...atributos}
					disabled={type == ""}
					danger={!!e.erro ? 1 : 0}
					onChange={(ev) => {
						if (type === "cnpj" && ev?.target) {
							ev.target.value = String(ev.target.value || "").toUpperCase()
						}
						handleCampo(ev)
					}}
				/>
				{!!e.erro ? <p className="text-danger">{e.erro}</p> : ""}
			</div>
		</div>
	</div>
}

export function AutocompleteCidade({ id, value, onChange, placeholder, obrigatorio, uf }) {
	const [input, setInput] = useState(value || "");
	const [todasCidades, setTodasCidades] = useState([]);
	const [sugestoes, setSugestoes] = useState([]);
	const [showSugestoes, setShowSugestoes] = useState(false);
	const [carregando, setCarregando] = useState(false);
	const inputRef = useRef(null);
	const ufRef = useRef(uf || "");

	const { dados } = useContext(ContextoGeral);

	useEffect(() => {
		if (inputRef.current) inputRef.current.dataset.valid = "0";
	}, []);

	// === AGORA A FUNÇÃO FICA AQUI, DISPONÍVEL PARA O onChange ===
	const carregar = async (nomeCidade = "a") => {
		if (!uf) return;
		setCarregando(true);
		try {
			const LIMITE = 10;
			const ufStr = String(uf ?? "").toUpperCase();

			const params = new URLSearchParams({
				siglaEstado: ufStr,
				limite: String(LIMITE),
				nomeCidade: nomeCidade || "a",
			});

			const api = new APISEM(dados.dominio);
			const resp = await api.buscarCidade(params);
			if (resp?.status === 400) throw new Error("Erro na API local");

			// adapta formatos possíveis
			const data = resp?.dados?.dados ?? resp?.dados ?? [];
			const pickNome = (c) =>
				(c && (c.nome ?? c.cidade ?? c.label ?? c.nomeCidade)) ||
				(typeof c === "string" ? c : undefined);

			const nomes =
				Array.isArray(data) ? data.map(pickNome).filter(Boolean)
					: Array.isArray(data?.result) ? data.result.map(pickNome).filter(Boolean)
						: Array.isArray(data?.data) ? data.data.map(pickNome).filter(Boolean)
							: Array.isArray(data?.cidades) ? data.cidades.map(pickNome).filter(Boolean)
								: [];

			setTodasCidades(nomes);
			setSugestoes(nomes);
			setShowSugestoes(nomes.length > 0);
		} catch (err) {
			console.error(err);
			setTodasCidades([]);
			setSugestoes([]);
			setShowSugestoes(false);
		} finally {
			setCarregando(false);
		}
	};

	// quando o UF mudar, limpa e carrega uma lista inicial
	useEffect(() => {
		if (!uf || uf === ufRef.current) return;

		ufRef.current = uf;
		setInput("");
		setSugestoes([]);
		setTodasCidades([]);
		setShowSugestoes(false);
		if (inputRef.current) inputRef.current.dataset.valid = "0";

		carregar("a"); // pré-popula
	}, [uf]);

	const handleSelect = (cidadeSelecionada) => {
		setInput(cidadeSelecionada);
		setShowSugestoes(false);
		setSugestoes([]);
		if (inputRef.current) inputRef.current.dataset.valid = "1";
		onChange && onChange(cidadeSelecionada);
	};

	// >>> chama a API TODA VEZ QUE DIGITAR <<<
	const handleInputChange = (e) => {
		const v = e.target.value;
		setInput(v);
		if (inputRef.current) inputRef.current.dataset.valid = "0";
		if (!showSugestoes) setShowSugestoes(true);
		carregar(v);
	};

	return (
		<div className="relative !border !border-black-300 rounded-md p-2">
			<input
				id={id}
				ref={inputRef}
				type="text"
				className="form-control font-normal !border-none !shadow-none peer"
				value={input}
				onFocus={() => uf && setShowSugestoes(true)}
				onChange={handleInputChange}
				onBlur={() => {
					setTimeout(() => {
						setShowSugestoes(false);
						if (inputRef.current && inputRef.current.dataset.valid === "0") {
							setInput("");
							onChange && onChange("");
						}
					}, 150);
				}}
				{...(obrigatorio ? { required: true } : {})}
				autoComplete="off"
				placeholder=" "
				disabled={!uf}
			/>
			<label
				htmlFor={id}
				className="absolute left-3 top-2 text-gray-400 transition-opacity pointer-events-none
          peer-not-placeholder-shown:opacity-0 peer-placeholder-shown:opacity-100"
			>
				{placeholder || "Digite a cidade"}
				{obrigatorio && <span className="text-red-500"> *</span>}
			</label>

			{uf && showSugestoes && (
				<div
					className="w-100 z-10 bg-white border rounded-md mt-1 shadow-sm absolute left-0 right-0"
					style={{ maxHeight: 220, overflowY: "auto" }}
				>
					{carregando && (
						<div className="px-4 py-3 text-sm text-gray-500">Carregando cidades…</div>
					)}

					{!carregando && sugestoes.length === 0 && (
						<div className="px-4 py-3 text-sm text-gray-500">Nenhuma cidade encontrada.</div>
					)}

					{!carregando &&
						sugestoes.map((cidade, i) => (
							<div
								key={i}
								className="px-4 py-3 hover:bg-blue-50 cursor-pointer"
								onMouseDown={() => handleSelect(cidade)}
							>
								{cidade}
							</div>
						))}
				</div>
			)}

			{!uf && (
				<div className="mt-2 text-xs text-gray-500">
					Selecione o estado para listar as cidades.
				</div>
			)}
		</div>
	);
}

